import { StaticImage } from "gatsby-plugin-image"
import React from "react"

export default function Sponsors({ language }) {
  return (
    <section className="greyish-grad">
      <div className="container">
        <h2>{language === "pt" ? "Apoiadores" : "Supporters"}</h2>
        <div className="row align-items-center justify-content-evenly">
          <div className="col-lg-2 col-md-4 col-sm-6 m-3 sponsors-card">
            <a
              href="https://www.humboldt-foundation.de/en/"
              className="text-decoration-none"
              target="_blank"
              rel="noopener noreferrer"
            >
              <StaticImage
                src="../../../assets/images/sponsors/avh.jpeg"
                alt="Alexander Von Humboldt - Stiftung/Foundation"
              />
            </a>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-6 m-3 sponsors-card">
            <a
              href="https://charite3r.charite.de/en/3r_service/camarades_berlin/"
              className="text-decoration-none"
              target="_blank"
              rel="noopener noreferrer"
            >
              <StaticImage
                src="../../../assets/images/sponsors/cde.png"
                alt="Camarades DE"
              />
            </a>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-6 m-3 sponsors-card">
            <a
              href="https://www.ed.ac.uk/clinical-brain-sciences/research/camarades"
              className="text-decoration-none"
              target="_blank"
              rel="noopener noreferrer"
            >
              <StaticImage
                src="../../../assets/images/sponsors/cuk.png"
                alt="Camarades UK"
              />
            </a>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-6 m-3 sponsors-card">
            <a
              href="https://ppgfarmaco.ufsc.br/"
              className="text-decoration-none"
              target="_blank"
              rel="noopener noreferrer"
            >
              <StaticImage
                src="../../../assets/images/sponsors/ppgfarmaco.png"
                alt="PPGFarmacologia UFSC"
              />
            </a>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-6 m-3 sponsors-card">
            <a
              href="https://ufsc.br/"
              className="text-decoration-none"
              target="_blank"
              rel="noopener noreferrer"
            >
              <StaticImage
                src="../../../assets/images/sponsors/ufsc.png"
                alt="UFSC"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
